import { render, staticRenderFns } from "./spring-festival-course-reservation.vue?vue&type=template&id=405cd87c&scoped=true&"
import script from "./spring-festival-course-reservation.vue?vue&type=script&lang=js&"
export * from "./spring-festival-course-reservation.vue?vue&type=script&lang=js&"
import style0 from "./spring-festival-course-reservation.vue?vue&type=style&index=0&id=405cd87c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "405cd87c",
  null
  
)

export default component.exports